import wixLocation from 'wix-location';

//var isDropDownVisible;
//var touchedDropDown;

$w.onReady(function () {
//	isDropDownVisible = false;
//	touchedDropDown = false;
});

export function buttonCompany_click(event) {
	$w('#dropdownBox').show(); // Showing the dropdown menu
	$w('#buttonCompany').disable(); // Disabling the button so the user cant click 

//Add this for new dropdown//
// 
	  //  $w('#mediaDropdownBox').hide(); // Showing the Media dropdown
		//$w('#buttonMedia').enable(); // Disabling the Media button so the user cant click 


//************************* *//
//	isDropDownVisible = true;
//	touchedDropDown = false;
}
export function buttonLawEnforcement_click(event) {
	wixLocation.to("/law-enforcement");
}
export function buttonResources_click(event) {
	wixLocation.to("/resources");
}
export function buttonMedia_click(event) {
	wixLocation.to("/media");
}
export function buttonOverview_click(event) {
	wixLocation.to("/overview");
}
export function buttonCareers_click(event) {
	wixLocation.to("/careers");
}
export function buttonContact_click(event) {
	wixLocation.to("/contact");
}
export function buttonAdvisory_click(event) {
wixLocation.to("/leadership");
}
export function buttonMedia_mouseIn(event) {
		$w('#dropdownBox').hide();
		$w('#buttonCompany').enable(); 
	   // $w('#mediaDropdownBox').show(); // Showing the dropdown
	//	$w('#buttonMedia').disable(); // Disabling the button so the user cant click 
}
export function dropdownBox_mouseOut(event) {
	$w('#dropdownBox').hide(); // Hiding the dropdown when the user leaves
	$w('#buttonCompany').enable(); // enabling the company button
	//isDropDownVisible = false;
}
//export function buttonCompany_mouseOut(event) {
//	if(isDropDownVisible === true && touchedDropDown === false) {
//		$w('#dropdownBox').hide();
//		$w('#buttonCompany').enable();
//	}
//}
//export function dropdownBox_mouseIn(event) {
	//touchedDropDown = true;
//}
export function buttonCompany_mouseIn(event) {
	$w('#dropdownBox').show();
	$w('#buttonCompany').disable();
	//isDropDownVisible = true;
	//touchedDropDown = false;
}

//export function buttonMedia_mouseOut(event) {



//}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 off of the element.

 > **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/tips-tutorials-examples/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
///export function mediaDropdownBox_mouseOut(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 

	//	$w('#mediaDropdownBox').hide(); // Hiding the dropdown when the user leaves
	//$w('#buttonMedia').enable(); // enabling the company button
//}